import Swiper from 'swiper';
import {Controller} from 'swiper/modules';
import BaseModule from './BaseModule';
import Factory from "../libs/Factory";
import {swiperSetup} from "../libs/SwiperSetup";
import {SwiperOptions} from "swiper/types";
import {requireElement, delegateListener} from "../libs/Helpers";

export default class CarFilter extends BaseModule {
    declare el: HTMLElement;
    rangeFilter: HTMLElement | null;
    swiper: Swiper;
    metaSwiper: Swiper | null;
    swiperType: string = "";
    swiperItems: NodeListOf<HTMLElement>;

    constructor(el: HTMLElement, factory: Factory) {
        super(el, factory, 'CarFilter');

        this.rangeFilter = el.querySelector('.range-filter');
        const rangeFilterSelect = el.querySelector<HTMLSelectElement>('.range-filter-select select');

        const rangeList = requireElement(el, '.range-list');
        this.swiperItems = rangeList.querySelectorAll('.range-list-item');

        this.swiperType = el.dataset.type ?? '';
        const swiperOpts: SwiperOptions = swiperSetup(rangeList, this.swiperType);

        if(this.swiperType === 'fancy'){
            this.metaSwiper = new Swiper(requireElement(el, '.range-meta'), {
                slidesPerView: 1,
                initialSlide: 1,
                centeredSlides: true,
                watchSlidesProgress: true,
            });
            swiperOpts.controller = {control: this.metaSwiper};
            swiperOpts.modules = swiperOpts.modules ?? [];
            swiperOpts.modules.push(Controller);

            swiperOpts.slidesPerView = 1;
            swiperOpts.breakpoints = {...swiperOpts.breakpoints, 767: {slidesPerView: 2}}; // 1024
        } else {
            swiperOpts.slidesPerView = 1;
            swiperOpts.breakpoints = {640: {slidesPerView: 2}};
            if (this.swiperItems.length > 4) {
                swiperOpts.breakpoints = {...swiperOpts.breakpoints, 767: {slidesPerView: 4}}; // 1024
            }
        }

        this.swiper = new Swiper(rangeList, swiperOpts);


        if (this.rangeFilter) {
            delegateListener(this.rangeFilter, 'click', 'button', (event, target) => {
                event.preventDefault();

                const filterClass = target.dataset.filter;
                if (filterClass) {
                    this.selectButton(filterClass);
                    this.updateList(filterClass);
                    if (rangeFilterSelect) {
                        rangeFilterSelect.value = filterClass;
                        rangeFilterSelect.dispatchEvent(new Event('input', {bubbles: true}));
                    }
                }
            });
        }

        rangeFilterSelect?.addEventListener('change', () => {
            const filterClass = rangeFilterSelect.value;
            if(filterClass){
                this.selectButton(filterClass);
                this.updateList(filterClass);
            }
        })
    }

    updateList(selected: string) {
        // add hidden if not all and not active
        this.swiperItems.forEach((item) => {
            item.classList.toggle('hidden', selected !== 'all' && !item.classList.contains(selected));
        });
        this.swiper.update();

        if(this.swiperType === 'fancy' && this.metaSwiper){
            this.metaSwiper.el.querySelectorAll(".range-list-item").forEach((item) => {
                item.classList.toggle('hidden', selected !== 'all' && !item.classList.contains(selected));
            });
            this.metaSwiper.update();
        }
    }

    selectButton(selector: string){
        this.rangeFilter?.querySelectorAll('button').forEach((button) => {
            button.classList.toggle('active', button.dataset.filter === selector);
        });
    }
}
